import { useEffect, useState } from 'react';

// Bottom-right toast with an Undo button, visible for `seconds` (default 10) after a single care-team change.
const UndoToast = ({ toast, onUndo, onClose, seconds = 10 }) => {
    const [left, setLeft] = useState(seconds);
    useEffect(() => {
        if (!toast) return undefined;
        setLeft(seconds);
        const timer = setInterval(() => setLeft((s) => s - 1), 1000);
        return () => clearInterval(timer);
    }, [toast, seconds]);
    useEffect(() => {
        if (toast && left <= 0) onClose();
    }, [left, toast, onClose]);
    if (!toast) return null;
    return (
        <div
            role="status"
            data-testid="care-team-toast"
            style={{
                position: 'fixed', right: '24px', bottom: '24px', zIndex: 2000, background: '#303030', color: '#fff',
                padding: '10px 14px', borderRadius: '6px', boxShadow: '0 2px 8px rgba(0,0,0,.3)', fontSize: '14px',
            }}
        >
            {toast.message}
            {toast.batchId && (
                <button type="button" className="btn btn-sm btn-light ml-3" onClick={() => onUndo(toast.batchId)}>
                    Undo ({Math.max(left, 0)}s)
                </button>
            )}
            <button type="button" className="btn btn-sm btn-link text-white ml-1" aria-label="Dismiss" onClick={onClose}>×</button>
        </div>
    );
};

export default UndoToast;
